import React from "react";

interface NewThreadIconProps {
    className?: string;
    color?: string;
    size?: "sm" | "md" | "lg" | "xl";
}

export const NewThreadIcon = ({
    className = "",
    color = "currentColor",
    size = "lg",
}: NewThreadIconProps) => {
    const sizeClasses = {
        sm: "w-5 h-5",   // ~20x20px
        md: "w-6 h-6",   // ~24x24px
        lg: "w-8 h-8",   // ~32x32px
        xl: "w-10 h-10", // ~40x40px
    };

    return (
        <div className="icon new-thread-icon">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.6"
                className={`${sizeClasses[size]} ${className}`}
                aria-hidden="true"
            >
                <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                <path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z" />
            </svg>
        </div>
    );
};

export default NewThreadIcon;